export default __webpack_public_path__ + "static/media/mybooksicon.51afe2ca.png";